var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 9,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.98093 15.1152C8.98093 15.1152 16.0574 12.1046 18.5116 11.0446C19.4524 10.6206 22.6429 9.26364 22.6429 9.26364C22.6429 9.26364 24.1155 8.67004 23.9927 10.1117C23.9518 10.7054 23.6246 12.783 23.2974 15.0304C22.8065 18.2106 22.2747 21.6876 22.2747 21.6876C22.2747 21.6876 22.1929 22.6628 21.4976 22.8324C20.8022 23.002 19.6569 22.2388 19.4524 22.0692C19.2887 21.942 16.3846 20.0339 15.3211 19.101C15.0347 18.8466 14.7075 18.3378 15.3619 17.7442C16.8345 16.3449 18.5934 14.6064 19.6569 13.5039C20.1477 12.9951 20.6386 11.8078 18.5934 13.2495C15.6892 15.3272 12.8259 17.2777 12.8259 17.2777C12.8259 17.2777 12.1714 17.7017 10.9443 17.3201C9.71716 16.9385 8.28552 16.4297 8.28552 16.4297C8.28552 16.4297 7.30388 15.7936 8.98093 15.1152Z",
    fill: "#B1D287"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.58a5a03cf958f5bc5fa648c0db77300d.svg";
export { ForwardRef as ReactComponent };